import * as api from 'registration/resources/registration.api';
import { checkAccess } from 'app/actions/app.actions';
import template from './complete-registration.html';

const mapStateToThis = ({ session, config }) => {
  const { phoneMask, phoneLength, maxFirstNameLength, maxLastNameLength, maxEmailLength } = config;

  return {
    session,
    phoneMask,
    phoneLength,
    maxFirstNameLength,
    maxLastNameLength,
    maxEmailLength,
  };
};

const mapDispatchToThis = {
  checkAccess,
};

// eslint-disable-next-line no-undef
@Inject('appFactory', '$ngRedux', '$stateParams', 'Notifications', '$state', 'gettextCatalog')
class CompleteRegistrationController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
    this.verifyAndLoadUser = this.appFactory.dispatch('registration.verifyAndLoadUser', true);
  }

  $onInit() {
    if (!this.checkAccess('registration.complete')) {
      this.$state.go('home-view');
    }
    this.formModel = {};
    this.verifyAndLoadUser
      .run(this.$stateParams.login, this.$stateParams.password, true)
      .then(() => {
        const { firstName, lastName, emailAddress, mobilePhone, contactPhone } = this.session;
        this.formModel = {
          firstName,
          lastName,
          emailAddress,
          mobilePhone,
          contactPhone,
        };
      })
      .catch(() => {
        this.$state.go('home-view');
      });
  }

  $onDestroy() {
    this.unsubscribe();
  }

  onSubmit($event, $formCtrl) {
    $event.stopPropagation();
    $event.preventDefault();

    return this.evalForm($formCtrl);
  }

  async evalForm($formCtrl) {
    $formCtrl.$setSubmitted();

    if ($formCtrl.$invalid) {
      return;
    }

    await api.confirmRegistration(this.formModel);
    await this.$state.go('user-logout');
  }
}

export default class CompleteRegistrationComponent {
  constructor() {
    this.template = template;
    this.controller = CompleteRegistrationController;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/registration/components/complete-registration/complete-registration-component.js